// src/components/co-brand-banner/co-brand-banner.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment CoBrandBannerStyleFragment on CoBrandBannerStyle {\n    __typename\n    desktop {\n      key\n      value\n    }\n    tablet {\n      key\n      value\n    }\n    mobile {\n      key\n      value\n    }\n    commonStyle {\n      key\n      value\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment CoBrandBannerLogoDetailFragment on CoBrandBannerLogoDetail {\n    __typename\n    imgSrc\n    style {\n      key\n      value\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment CoBrandBannerLogoDataFragment on CoBrandBannerLogoData {\n    __typename\n    desktop {\n      ...CoBrandBannerLogoDetailFragment\n    }\n    tablet {\n      ...CoBrandBannerLogoDetailFragment\n    }\n    mobile {\n      ...CoBrandBannerLogoDetailFragment\n    }\n    altText\n    href\n    logoContainerStyle {\n      ...CoBrandBannerStyleFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment CoBrandBannerStylesFragment on CoBrandBannerStyles {\n    __typename\n    mainContainer {\n      ...CoBrandBannerStyleFragment\n    }\n    subContainer {\n      ...CoBrandBannerStyleFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment CoBrandBannerTextTokenFragment on CoBrandBannerTextToken {\n    __typename\n    text\n    href\n    style {\n      key\n      value\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment CoBrandBannerTextSectionFragment on CoBrandBannerTextSection {\n    __typename\n    textTokens {\n      ...CoBrandBannerTextTokenFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment CoBrandBannerTextDataFragment on CoBrandBannerTextData {\n    __typename\n    textSections {\n      __typename\n      ...CoBrandBannerTextSectionFragment\n    }\n    textContainerStyle {\n      ...CoBrandBannerStyleFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  query CoBrandBannerQuery($context: ContextInput!) {\n    coBrandBanner(context: $context) {\n      __typename\n      logoData {\n        __typename\n        ...CoBrandBannerLogoDataFragment\n      }\n      textData {\n        __typename\n        ...CoBrandBannerTextDataFragment\n      }\n      styles {\n        __typename\n        ...CoBrandBannerStylesFragment\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
import React8 from "react";
import { gql as gql8, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-logo-data.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-logo-detail.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
// src/components/co-brand-banner/common/converter.ts
var generateStyleObjFromProperties = function (properties) {
  var style = {};
  if (properties !== null) {
    properties.forEach(function (property) {
      style[property.key] = property.value;
    });
  }
  return style;
};
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-style.tsx
import React from "react";
import { gql } from "@apollo/client";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment = gql(_templateObject());
var CoBrandBannerStyle = function (props) {
  var children = props.children,
    data = props.data;
  if (!data) {
    return null;
  }
  var commonStyle = generateStyleObjFromProperties(data.commonStyle);
  var desktopStyle = _object_spread({}, generateStyleObjFromProperties(data.desktop), commonStyle);
  var tabletStyle = _object_spread({}, generateStyleObjFromProperties(data.tablet), commonStyle);
  var mobileStyle = _object_spread({}, generateStyleObjFromProperties(data.mobile), commonStyle);
  return /* @__PURE__ */React.createElement(Viewport, null, /* @__PURE__ */React.createElement(ViewLarge, null, /* @__PURE__ */React.createElement("div", {
    style: desktopStyle,
    className: "co-brand-banner-style",
    "data-stid": "co-brand-banner-style"
  }, children)), /* @__PURE__ */React.createElement(ViewMedium, null, /* @__PURE__ */React.createElement("div", {
    style: tabletStyle,
    className: "co-brand-banner-style",
    "data-stid": "co-brand-banner-style"
  }, children)), /* @__PURE__ */React.createElement(ViewSmall, null, /* @__PURE__ */React.createElement("div", {
    style: mobileStyle,
    className: "co-brand-banner-style",
    "data-stid": "co-brand-banner-style"
  }, children)));
};
CoBrandBannerStyle.fragment = _object_spread_props(_object_spread({}, fragment), {
  __typename: "CoBrandBannerStyle"
});
CoBrandBannerStyle.displayName = "CoBrandBannerStyle";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-logo-detail.tsx
var fragment2 = gql2(_templateObject1(), CoBrandBannerStyle.fragment);
var CoBrandBannerLogoDetail = function (props) {
  var data = props.data,
    altText = props.altText,
    href = props.href,
    view = props.view;
  if (!data) {
    return null;
  }
  var style = generateStyleObjFromProperties(data.style);
  var imageStyle = {
    backgroundImage: "url(".concat(data.imgSrc, ")"),
    backgroundRepeat: "no-repeat",
    backgroundSize: "".concat(style.width, " ").concat(style.height),
    width: "".concat(style.width),
    height: "".concat(style.height)
  };
  delete style.width;
  delete style.height;
  var viewSize = view !== void 0 ? "-".concat(view) : "";
  return /* @__PURE__ */React2.createElement("div", {
    style: style,
    className: "co-brand-banner-logo-inner-section",
    "data-stid": "co-brand-banner-logo-inner-section"
  }, href ? /* @__PURE__ */React2.createElement("a", {
    href: href,
    target: "_blank",
    rel: "noopener"
  }, /* @__PURE__ */React2.createElement("div", {
    role: "img",
    "aria-label": altText,
    style: imageStyle,
    className: "co-brand-banner-logo-div".concat(viewSize)
  })) : /* @__PURE__ */React2.createElement("div", {
    role: "img",
    "aria-label": altText,
    style: imageStyle,
    className: "co-brand-banner-logo-div".concat(viewSize)
  }));
};
CoBrandBannerLogoDetail.fragment = _object_spread_props(_object_spread({}, fragment2), {
  __typename: "CoBrandBannerLogoDetail"
});
CoBrandBannerLogoDetail.displayName = "CoBrandBannerLogoDetail";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-logo-data.tsx
var fragment3 = gql3(_templateObject2(), CoBrandBannerLogoDetail.fragment, CoBrandBannerStyle.fragment);
var CoBrandBannerLogoData = function (props) {
  var data = props.data;
  if (!data) {
    return null;
  }
  return /* @__PURE__ */React3.createElement(CoBrandBannerStyle, {
    data: data.logoContainerStyle
  }, /* @__PURE__ */React3.createElement(Viewport2, null, /* @__PURE__ */React3.createElement(ViewLarge2, null, /* @__PURE__ */React3.createElement(CoBrandBannerLogoDetail, {
    data: data.desktop,
    altText: data.altText,
    href: data.href,
    view: "large"
  })), /* @__PURE__ */React3.createElement(ViewMedium2, null, /* @__PURE__ */React3.createElement(CoBrandBannerLogoDetail, {
    data: data.tablet,
    altText: data.altText,
    href: data.href,
    view: "medium"
  })), /* @__PURE__ */React3.createElement(ViewSmall2, null, /* @__PURE__ */React3.createElement(CoBrandBannerLogoDetail, {
    data: data.mobile,
    altText: data.altText,
    href: data.href,
    view: "small"
  }))));
};
CoBrandBannerLogoData.fragment = _object_spread_props(_object_spread({}, fragment3), {
  __typename: "CoBrandBannerLogoData"
});
CoBrandBannerLogoData.displayName = "CoBrandBannerLogoData";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-styles.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
var fragment4 = gql4(_templateObject3(), CoBrandBannerStyle.fragment);
var CoBrandBannerStyles = function (props) {
  var children = props.children,
    data = props.data;
  if (!data) {
    return null;
  }
  return /* @__PURE__ */React4.createElement(CoBrandBannerStyle, {
    data: data.mainContainer
  }, /* @__PURE__ */React4.createElement(CoBrandBannerStyle, {
    data: data.subContainer
  }, children));
};
CoBrandBannerStyles.fragment = _object_spread_props(_object_spread({}, fragment4), {
  __typename: "CoBrandBannerStyles"
});
CoBrandBannerStyles.displayName = "CoBrandBannerStyles";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-text-data.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-text-section.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-text-token.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
var fragment5 = gql5(_templateObject4());
var CoBrandBannerTextToken = function (props) {
  var data = props.data;
  var href = data.href,
    style = data.style,
    text = data.text;
  if (href && style) {
    return /* @__PURE__ */React5.createElement("a", {
      className: "co-brand-banner-text-token",
      href: href,
      target: "_blank",
      rel: "noopener",
      style: generateStyleObjFromProperties(style)
    }, text);
  }
  if (href) {
    return /* @__PURE__ */React5.createElement("a", {
      href: href,
      target: "_blank",
      rel: "noopener"
    }, text);
  }
  if (style) {
    return /* @__PURE__ */React5.createElement("span", {
      className: "co-brand-banner-text-token",
      style: generateStyleObjFromProperties(style)
    }, text);
  }
  return /* @__PURE__ */React5.createElement(React5.Fragment, null, text);
};
CoBrandBannerTextToken.fragment = _object_spread_props(_object_spread({}, fragment5), {
  __typename: "CoBrandBannerTextToken"
});
CoBrandBannerTextToken.displayName = "CoBrandBannerTextToken";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-text-section.tsx
var fragment6 = gql6(_templateObject5(), CoBrandBannerTextToken.fragment);
var CoBrandBannerTextSection = function (props) {
  var data = props.data;
  if (!data || !data.textTokens || data.textTokens.length === 0) {
    return null;
  }
  return /* @__PURE__ */React6.createElement(React6.Fragment, null, data.textTokens.map(function (token, i) {
    return /* @__PURE__ */React6.createElement(CoBrandBannerTextToken, {
      data: token,
      key: CoBrandBannerTextToken.displayName + i
    });
  }));
};
CoBrandBannerTextSection.fragment = _object_spread_props(_object_spread({}, fragment6), {
  __typename: "CoBrandBannerTextSection"
});
CoBrandBannerTextSection.displayName = "CoBrandBannerTextSection";
// src/components/co-brand-banner/__private/__fragments/co-brand-banner-text-data.tsx
var fragment7 = gql7(_templateObject6(), CoBrandBannerTextSection.fragment, CoBrandBannerStyle.fragment);
var CoBrandBannerTextData = function (props) {
  var data = props.data;
  if (!data) {
    return null;
  }
  var textSections = data.textSections,
    textContainerStyle = data.textContainerStyle;
  return /* @__PURE__ */React7.createElement(CoBrandBannerStyle, {
    data: textContainerStyle
  }, /* @__PURE__ */React7.createElement("div", {
    className: "cobrand-banner-text-section",
    "data-stid": "cobrand-banner-text-section"
  }, textSections.map(function (section, i) {
    return /* @__PURE__ */React7.createElement(React7.Fragment, {
      key: CoBrandBannerTextSection.displayName + i
    }, /* @__PURE__ */React7.createElement(CoBrandBannerTextSection, {
      data: section
    }), i < textSections.length - 1 ? /* @__PURE__ */React7.createElement("br", null) : "");
  })));
};
CoBrandBannerTextData.fragment = _object_spread_props(_object_spread({}, fragment7), {
  __typename: "CoBrandBannerTextData"
});
CoBrandBannerTextData.displayName = "CoBrandBannerTextData";
// src/components/co-brand-banner/co-brand-banner.tsx
var __CoBrandBannerQuery = gql8(_templateObject7(), CoBrandBannerLogoData.fragment, CoBrandBannerTextData.fragment, CoBrandBannerStyles.fragment);
var CoBrandBanner = function (props) {
  var skipSsr = props.skipSsr;
  var context = useBexApi().context;
  var variables = {
    context: context
  };
  var _useQuery = useQuery(__CoBrandBannerQuery, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !data || !data.coBrandBanner.logoData && !data.coBrandBanner.textData) {
    return null;
  }
  var coBrandBanner = data.coBrandBanner;
  var textData = coBrandBanner.textData;
  var logoData = coBrandBanner.logoData;
  var styles = coBrandBanner.styles;
  return /* @__PURE__ */React8.createElement("div", {
    className: "co-brand-banner"
  }, /* @__PURE__ */React8.createElement(CoBrandBannerStyles, {
    data: styles
  }, logoData && /* @__PURE__ */React8.createElement(CoBrandBannerLogoData, {
    data: logoData
  }), textData && /* @__PURE__ */React8.createElement(CoBrandBannerTextData, {
    data: textData
  })));
};
CoBrandBanner.displayName = "sharedui-CoBrandBanner";
export { CoBrandBanner }; /* istanbul ignore next -- @preserve */